import React, { Component } from 'react';
import './tags-page.style.css';
import axios from 'axios'
import {
    Link, Redirect
} from 'react-router-dom'


const EachSuggestTags = (props) => (
    <div className="each-suggest-tag-wrap">
        <div className="est-cover" style={{ backgroundColor: props.tagColor }}>
        </div>
        <div className="est-data">
            <div className="est-head">
                <Link to={`/tag/${props.tagName}`}>
                    <div className="est-image" style={{ backgroundImage: `url(${props.tagImage})` }}>


                    </div>
                </Link>
                <div className="est-head-text">
                    <Link to={`/tag/${props.tagName}`}>
                        <div className="est-ht-header">
                            {props.tagName}
                        </div>
                    </Link>
                    <div className="est-ht-des">
                        ถูกพูดถึงใน {props.tagCount} โพสต์
                    </div>
                </div>
            </div>
            <div className="est-des ellipsis-three-lines">
                {props.tagDes}
            </div>
            <div className="est-bottom">
            </div>
        </div>
    </div>
)

export default class TagsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: []

        };
    }



    componentDidMount() {
        let self = this;
        window.scrollTo(0,0)
        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/tags`,
            headers: {
                'Content-Type': 'multipart/form-data',


            }
        })
            .then(function (response) {
                self.setState({ tags: response.data })
            })
            .catch(function (response) {
                // console.log("nope")
            });

    }


    render() {

        return (
            <div className="wrap">

                <div className="content-wrap">
                    <div className="card-wrap">
                        <div className="blog-header">
                            <div className="ml-10px">
                                <div className="blog-header-title tags-page-header">แท็กทั้งหมด</div>
                                <div className="blog-header-subtitle">ความรู้หลากหลาย แต่เลือกอ่านเฉพาะหัวข้อที่ชอบก็ได้</div>
                            </div>
                        </div>
                        <div className="suggest-tag-wrap">
                            {this.state.tags.map((tag, i) => <EachSuggestTags tagName={tag.tagName} tagColor={tag.tagColor1} tagCount={tag.count} tagDes={tag.tagDescription} tagImage={tag.tagLogo} />)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
